
import { Popover, Transition } from "@headlessui/react";
import { IoCloseOutline } from "react-icons/io5";
import { BiMenuAltRight } from "react-icons/bi";
import { useState, Fragment } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";


const navigations = [
  {
    name: "Home",
    href: "/",
  },
  {
    name: "Arena",
    href: "/channels/arena",
  },
  {
    name: "Nexa",
    href: "/channels/nexa",
  },
  {
    name: "Commercial",
    href: "/channels/commercial",
  },
  {
    name: "Suzuki",
    href: "/channels/suzuki",
  },
  // {
  //   name: "Truevalue",
  //   href: "/truevalue",
  // },
  {
    name: "Finance",
    href: "/finance",
  },
  {
    name: "Insurance",
    href: "/insurance",
  },
  {
    name: "Book A Service",
    href: "/book-a-service",
  },
  {
    name: "Driving School",
    href: "/driving-school",
  },
  {
    name: "Contact",
    href: "/contact-us",
  },
  {
    name: "Gallery",
    href: "/gallery",
  },
  {
    name: "Outlets",
    href: "/outlets",
  },
];

function MobileHeader() {
  const [openTrueValue, setOpenTrueValue] = useState(false);
  // const [navbar, setNavbar] = useState(false);
  // const fixedNavbar = () => {
  //   if (window.scrollY >= 100) {
  //     setNavbar(true);
  //   } else {
  //     setNavbar(false);
  //   }
  // };
  // window.addEventListener("scroll", fixedNavbar);
  const location = useLocation();

  useEffect(() => {
    setOpenTrueValue(false);
  }, [location]);
  return (
    <>
      <Popover className="relative z-50 lg:hidden">
        <div className="px-4 mx-auto max-w-7xl sm:px-6">
          <div className="flex items-center justify-between py-2 lg:justify-start md:space-x-10">
            <div className="flex justify-start lg:w-0 lg:flex-1">
              <Link to="/">
                <img
                  className="w-auto h-16"
                  loading="eager"
                  src={require("../../assets/logo.png")}
                  alt="logo"
                />
              </Link>
            </div>
            <div className="-my-2 -mr-2 lg:hidden">
              <Popover.Button className="text-gray-400 outline-none hover:text-gray-500 hover:bg-gray-100 focus:outline-none">
                <span className="sr-only">Open menu</span>
                <BiMenuAltRight className="w-6 h-6" aria-hidden="true" />
              </Popover.Button>
            </div>
          </div>
        </div>

        <Transition
          as={Fragment}
          enter="duration-200 ease-out"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="duration-100 ease-in"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Popover.Panel
            focus
            className="absolute inset-x-0 top-0 p-2 transition origin-top-right transform lg:hidden"
          >
            <div className="bg-white divide-y-2 rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 divide-gray-50">
              <div className="px-5 pt-5 pb-6">
                <div className="flex items-center justify-between">
                  <div>
                    <img
                      className="w-auto h-16"
                      src={require("../../assets/logo.png")}
                      loading="eager"
                      alt="Workflow"
                    />
                  </div>
                  <div className="-mr-2">
                    <Popover.Button className="inline-flex items-center justify-center p-2 text-gray-400 bg-white rounded-md outline-none hover:text-gray-500 hover:bg-gray-100 focus:outline-none ">
                      <span className="sr-only">Close menu</span>
                      <IoCloseOutline className="w-6 h-6" aria-hidden="true" />
                    </Popover.Button>
                  </div>
                </div>
                <div className="mt-6">
                  <nav className="grid gap-y-8">
                    {navigations.map((item) => (
                      <Popover.Button
                        as={Link}
                        key={item.name}
                        to={item.href}
                        className="flex items-center w-full p-3 -m-3 text-left rounded-md hover:bg-gray-50"
                      >
                        <span className="ml-3 text-base font-medium text-gray-900">
                          {item.name}
                        </span>
                      </Popover.Button>
                    ))}

                    {/* TRUEVALUE DROPDOWN */}
                    <div className="rounded-md">
                      <button
                        onClick={() => setOpenTrueValue(!openTrueValue)}
                        className="flex items-center justify-between w-full p-3 -m-3 text-left rounded-md hover:bg-gray-50"
                      >
                        <span className="ml-3 text-base font-medium text-gray-900">
                          Truevalue
                        </span>
                        <span className="mr-2 text-xl">
                          {openTrueValue ? "−" : "+"}
                        </span>
                      </button>

                      {/* DROPDOWN ITEMS */}
                      {openTrueValue && (
                        <div className="mt-2 ml-6 space-y-2">
                          <Link
                            to="/used-cars-sale"
                            className="block p-2 text-sm text-gray-700 rounded-md hover:bg-gray-100"
                          >
                            Buy a Car
                          </Link>
                          <Link
                            to="/sell-old-cars"
                            className="block p-2 text-sm text-gray-700 rounded-md hover:bg-gray-100"
                          >
                            Sell a Car
                          </Link>
                        </div>
                      )}
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </Popover.Panel>
        </Transition>
      </Popover>
    </>
  );
}

export default MobileHeader;
